export const BASE_ATTRIBUTES = {
  price: 1,
  compare_at_price: 2,
  cost: 3,
  quantity: 4,
} as const

export const BASE_ATTRIBUTES_VALUES = Object.values(BASE_ATTRIBUTES) as number[]
